var React = require('react');

function IconThumbdownSolid (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M64.2 106.9H227v488.2H64.2V106.9zm895.1 447.6c0 44.8-36.6 81.4-81.4 81.4H621.2l38.7 185.9 1.2 13c0 16.7-6.9 32.1-17.9 43.1l-43.1 42.7-267.8-268c-15.1-14.6-24-35-24-57.4V188.3c0-44.8 36.6-81.4 81.4-81.4h366.2c33.8 0 62.7 20.3 74.9 49.6l122.9 286.8c3.7 9.4 5.7 19.1 5.7 29.7v77.7l-.4.4.3 3.4z"}));
}

IconThumbdownSolid.displayName = "IconThumbdownSolid";

IconThumbdownSolid.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconThumbdownSolid;

IconThumbdownSolid.default = IconThumbdownSolid;
